/**
 * Listing Title Service
 *
 * Derives the listing sheet header title directly from the active chip key. Deliberately
 * separate from the map chip's own button label (services/mapChipService.js's MAP_CHIPS[].label)
 * — the listing title uses different copy for the Model state ('Model Homes' vs the chip's
 * 'Model'), per product spec (Confluence 5759270937).
 *
 * @module nativeInteractiveSiteMap/services/listingTitleService
 */

import LotStatus from '../enums/lotStatus';

const LISTING_TITLES = {
  [LotStatus.Available.toString()]:  'Available',
  [LotStatus.Model.toString()]:      'Model Homes',
  [LotStatus.ComingSoon.toString()]: 'Coming Soon',
  [LotStatus.Sold.toString()]:       'Sold',
};

/**
 * @param {string} chipKey - the active chip key, e.g. from redux/selectors.js#selectActiveChip
 * @returns {string} listing sheet header title — falls back to the Available title for an
 * unrecognized chipKey so the header never renders `undefined`
 */
export default function getListingTitle(chipKey) {
  return LISTING_TITLES[chipKey] ?? LISTING_TITLES[LotStatus.Available.toString()];
}
